import LocationUtil from "../common/utils/LocationUtil";

class TechnologyPreviewItem {
  // ---------------------------------------------------------------------------
  // --	TechnologyPreviewItem
  // ---------------------------------------------------------------------------

  constructor(elm) {
    //モード
    this.mode = "";

    //遷移値
    this.rate = 0;

    //DOM参照
    this.$elm = elm;
    this.$photo = this.$elm.querySelector(".p-home-technology__preview-photo");
    this.$img = this.$photo.querySelector("img");

    //リセット
    this.reset();
  }

  reset() {
    this.$elm.style.display = "none";
  }

  show(duration = 1.4) {
    //表示
    this.$elm.style.display = "block";

    //イメージのアンカーを変更
    this.$img.style.transformOrigin = "right top";

    //初期表示
    gsap.killTweensOf(this.$elm);
    gsap.set(this.$elm, {
      x: 0,
    });
    gsap.killTweensOf(this.$photo);
    gsap.set(this.$photo, {
      x: 0,
    });
    gsap.killTweensOf(this.$img);
    gsap.set(this.$img, {
      scaleX: 1.3,
      scaleY: 1.3,
    });

    //TWEEN
    gsap.to(this.$img, {
      scaleX: 1.0,
      scaleY: 1.0,
      duration: duration,
      ease: "power3.out",
    });
  }

  hide(duration = 1.2) {
    //イメージのアンカーを変更
    this.$img.style.transformOrigin = "left bottom";

    //Tween
    gsap.killTweensOf(this.$elm);
    gsap.to(this.$elm, {
      x: "120.7rem",
      duration: duration,
      ease: "expo.out",
    });
    gsap.killTweensOf(this.$photo);
    gsap.to(this.$photo, {
      x: "-120.7rem",
      duration: duration,
      ease: "expo.out",
    });
    gsap.killTweensOf(this.$img);
    gsap.to(this.$img, {
      scaleX: 1.3,
      scaleY: 1.3,
      duration: 1.0,
      ease: "expo.out",
      onComplete: this.reset.bind(this),
    });
  }

  // ---------------------------------------------------------------------------
}

export default TechnologyPreviewItem;
